import { format, parseISO } from 'date-fns';

import type { Order } from '@/entities/order';

import { inspectionsCopy } from './copy';

/**
 * De werklijst als CSV, zoals Excel in Nederland hem opent: puntkomma's als
 * scheiding, een komma in bedragen, en een BOM zodat é en ë goed binnenkomen.
 */
const SEPARATOR = ';';

function cell(value: string | null | undefined): string {
    const text = value ?? '';

    return /[";\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

function dutchAmount(amount: string | null): string {
    return amount === null ? '' : amount.replace('.', ',');
}

export function ordersToCsv(orders: readonly Order[], options: { money: boolean }): string {
    const headers = inspectionsCopy.csvHeaders;
    const columns = [
        headers.number,
        headers.status,
        headers.scheduledAt,
        headers.address,
        headers.postcode,
        headers.city,
        headers.service,
        headers.inspector,
        headers.client,
        ...(options.money ? [headers.price] : []),
    ];

    const rows = orders.map((order) => [
        order.number,
        order.statusLabel,
        order.scheduledAt ? format(parseISO(order.scheduledAt), 'dd-MM-yyyy HH:mm') : '',
        `${order.property.street} ${order.property.houseNumber}${order.property.houseNumberSuffix ?? ''}`,
        order.property.postcode,
        order.property.city,
        order.serviceLabel,
        order.assignee?.name ?? '',
        order.client.name,
        ...(options.money ? [dutchAmount(order.financials?.price ?? null)] : []),
    ]);

    return `\uFEFF${[columns, ...rows].map((row) => row.map(cell).join(SEPARATOR)).join('\r\n')}\r\n`;
}

/** Biedt de CSV aan als download, zonder tussenkomst van de server. */
export function downloadCsv(fileName: string, csv: string): void {
    const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }));
    const link = document.createElement('a');

    link.href = url;
    link.download = fileName;
    link.rel = 'noopener';
    document.body.append(link);
    link.click();
    link.remove();

    setTimeout(() => URL.revokeObjectURL(url), 0);
}
